import type { ComponentProps, ComponentType, ReactNode } from 'react'
import MUIHidden from '@material-ui/core/Hidden'

const Hidden = MUIHidden as ComponentType<
  ComponentProps<typeof MUIHidden> & {
    children: ReactNode
  }
>

export default Hidden
